export default "__VITE_ASSET__BlI4UoOt__"